import type { UserOrgRoleRole } from "../../generated/core-api";

const ROLE_RANK: Record<UserOrgRoleRole, number> = {
  member: 1,
  admin: 2,
};

/**
 * Returns roles the user may assign on a service account org_role entry.
 * Users cannot assign a role higher than their own in the target org.
 */
export function assignableOrgRoles(
  userRole: UserOrgRoleRole | undefined,
  isProvisioner: boolean,
): UserOrgRoleRole[] {
  if (isProvisioner) {
    return ["member", "admin"];
  }
  if (!userRole) {
    return [];
  }
  if (userRole === "admin") {
    return ["member", "admin"];
  }
  return ["member"];
}

export function canAssignOrgRole(
  userRole: UserOrgRoleRole | undefined,
  targetRole: UserOrgRoleRole,
  isProvisioner: boolean,
): boolean {
  return assignableOrgRoles(userRole, isProvisioner).includes(targetRole);
}

export function maxAssignableRole(
  userRole: UserOrgRoleRole | undefined,
  isProvisioner: boolean,
): UserOrgRoleRole {
  if (isProvisioner) {
    return "admin";
  }
  return userRole === "admin" ? "admin" : "member";
}

export function roleRank(role: UserOrgRoleRole): number {
  return ROLE_RANK[role];
}
